import React, { useState } from "react";
import AddButton from "@core/buttons/atoms/AddButton";
import AddModal from "@core/modals/AddModal";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import HullMaterialService from "@services/HullMaterialService";
import HullMaterialEUSelect from "@components/HullMaterialEU/partials/HullMaterialEUSelect";

const CreateHullMaterial = ({ onAdded }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [description, setDescription] = useState("");
  const [selectedHullMaterialEU, setSelectedHullMaterialEU] = useState();

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setDescription("");
    setNameEn("");
    setSelectedHullMaterialEU("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    HullMaterialService.create(
      name,
      nameEn,
      selectedHullMaterialEU,
      description
    )
      .then(() => {
        showSuccess(t("hullMaterialCreatedSuccessfully"));
        closeModal();
        onAdded();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"create_hull_materials"}>
      <AddButton
        label={t("addHullMaterial")}
        onClick={() => setShowModal(true)}
      />
      <AddModal
        show={showModal}
        title={t("addHullMaterial")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={nameEn}
            onChange={setNameEn}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-sm font-semibold mb-2 flex">
              {t("hullMaterialsEU")}
            </div>
            <HullMaterialEUSelect
              openModal={showModal}
              onSelect={setSelectedHullMaterialEU}
              selected={selectedHullMaterialEU}
            />
          </div>
        </div>
      </AddModal>
    </PermissionHandler>
  );
};

export default CreateHullMaterial;
